import { memo, useEffect, useState } from "react";
import "./JobActivity.css";
import EachJob from "../../../components/activity/EachJob";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../components/customButton/CustomButton";
import useApplicationStatus from "../../../hook/useApplicationStatus";
import PaginationContainer from "../../../components/paginationContainer/PaginationContainer";

const JobActivity = () => {
  const { id } = useParams();
  const [status, setStatus] = useState(id ? Number(id) : 1);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const {
    isLoading,
    data,
    fillTimeSheetJob,
    isFillTimeSheet,
    filters,
    setFilters,
  } = useApplicationStatus();

  useEffect(() => {
    if (status === 1) {
      setFilters((prev) => ({ ...prev, status: 1, type: "" }));
    } else if (status === 2) {
      setFilters((prev) => ({ ...prev, status: 0, type: "combined" }));
    } else if (status === 3) {
      setFilters((prev) => ({ ...prev, status: 4, type: "" }));
    } else if (status === 4) {
      setFilters((prev) => ({ ...prev, status: 5, type: "" }));
    } else if (status === 5) {
      setFilters((prev) => ({ ...prev, status: 6, type: "" }));
    } else if (status === 6) {
      setFilters((prev) => ({ ...prev, status: null, type: "saved_job" }));
    }

    setJobs(data?.data);
  }, [status, setFilters, data]);

  const onPageChange = (pageNumber) => {
    setFilters((prev) => ({ ...prev, page: pageNumber }));
  };

  console.log("expected", data, jobs);

  return (
    <div className="job-activity-container">
      <div className="job-activity-right">
        <div className="job-activity-right-top">
          <div className="activity-box-head">
            <h2>Job Activity</h2>

            <CustomButton
              customStyles={{
                width: "95px",
                height: "40px",
                marginTop: "0",
                fontSize: "14px",
                borderRadius: "5px",
              }}
              title="Post Job"
              onClick={() => navigate("/postjob")}
            />
          </div>
        </div>

        <div className="job-activity-right-bottom">
          <div className="job-activity-box">
            <div className="job-activity-tabs">
              <span
                onClick={() => setStatus(1)}
                className={status === 1 ? "active" : ""}
              >
                Applied
              </span>
              <span
                onClick={() => setStatus(2)}
                className={status === 2 ? "active" : ""}
              >
                Shortlisted
              </span>
              <span
                onClick={() => setStatus(4)}
                className={status === 4 ? "active" : ""}
              >
                Ongoing
              </span>
              <span
                onClick={() => setStatus(5)}
                className={status === 5 ? "active" : ""}
              >
                Completed
              </span>
              <span
                onClick={() => setStatus(3)}
                className={status === 3 ? "active" : ""}
              >
                Declined
              </span>
              <span
                onClick={() => setStatus(6)}
                className={status === 6 ? "active" : ""}
              >
                Saved
              </span>
            </div>
            <PaginationContainer
              loading={isLoading}
              data={jobs ?? []}
              onPageChange={onPageChange}
              page={filters.page}
              total={data?.meta?.allCount ?? 0}
            >
              <div className="job-activity-content">
                {jobs?.map((job) => {
                  return (
                    <div key={job.job_id} className="job-activity-jobItem">
                      <EachJob
                        job={job}
                        status={status}
                        fillTimeSheetJob={fillTimeSheetJob}
                        loading={isFillTimeSheet}
                      />
                    </div>
                  );
                })}
              </div>
            </PaginationContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(JobActivity);
